import _ from 'lodash';
import $ from 'jquery';
import angular from 'angular';
import template from './template.html';
import logger from '../../../shared/logger';
import './style.scss';
import UtilsService from '../../../services/utilsService';

export class CreateJobComponent {
    /* @ngInject */
    constructor(
        RouteService,
        dynamicDataService,
        staticDataService,
        $timeout,
        $state,
        LocationService,
        PositionService,
        $q,
        $localStorage,
        $cookies,
        $stateParams,
        TalentService,
        $rootScope,
        $http,
        permissions,
        EmployerService,
        CandidateService,
        TalentScoreService,
        CommonCodeService,
        utils,
        $scope,
        WebAppRouteService,
        RecruiterService,
    ) {
        const createJobCtrl = this;
        createJobCtrl.isSuperUser = permissions.isTalentExpertUser() || permissions.isTalenyaUser();

        createJobCtrl.init = async function () {
            staticDataService.getStaticData('countries', (data) => {
                createJobCtrl.lookupCountries = data;
            });

            this.utils = utils;
            createJobCtrl.isEmployer = true;
            let employerRepId;
            let recruiterId;

            const userPrefs = UtilsService.parseJSON($cookies.get('userprefs'));
            const userData = UtilsService.parseJSON($cookies.get('userData'));

            if (createJobCtrl.employerCtrl) {
                createJobCtrl.talenyaUser = createJobCtrl.employerCtrl.talenyaUser;
                createJobCtrl.accountManager = createJobCtrl.employerCtrl.accountManager;
                createJobCtrl.employerData = createJobCtrl.employerCtrl.employerData;
                employerRepId = (createJobCtrl.employerCtrl.employerRepData && createJobCtrl.employerCtrl.employerRepData._id);
            } else if (createJobCtrl.recruiterCtrl) {
                EmployerService.getEmployer($stateParams.employerId)
                    .then((response) => {
                        createJobCtrl.employerData = response.result;
                    })
                    .catch((err) => logger.error(err));
                if (!$stateParams.positionId) {
                    return $state.go('recruiter.positions');
                }
                if (!$stateParams.employerId) {
                    return $state.go('recruiter.openPosition', { positionId: $stateParams.positionId });
                }
                createJobCtrl.isEmployer = false;
                createJobCtrl.talenyaUser = createJobCtrl.recruiterCtrl.talenyaUser;
                createJobCtrl.accountManager = createJobCtrl.recruiterCtrl.accountManager;
            }
            if (permissions.isTalentExpertUser() && userPrefs?.entityId) {
                recruiterId = userPrefs.entityId;
            }
            createJobCtrl.location = {};
            $http.get('../resources/areaCode.json')
                .then((response) => {
                    createJobCtrl.areaCode = response.data;
                })
                .catch((err) => logger.error(err));
            LocationService.getLocations()
                .then((data) => {
                    createJobCtrl.location = data.data;
                    createJobCtrl.location.countries[1].states[''] = _.map(createJobCtrl.location.countries[1].states[''], 'text');
                })
                .catch((err) => logger.error(err));

            staticDataService.getStaticData('languages', (data) => {
                createJobCtrl.lookupLanguages = data;
            });

            const { result: recruiterList } = createJobCtrl.isSuperUser
                ? await RecruiterService.getRecruiters(['_id', 'fullName'])
                : [];

            const recruiterOptions = _.chain(recruiterList)
                .reduce((accumulator, { _id, fullName }) => {
                    if (!fullName) {
                        return accumulator;
                    }
                    return [
                        ...accumulator,
                        { value: _id, label: fullName, sorting: fullName.toLowerCase() },
                    ];
                }, [])
                .sortBy(['sorting'])
                .value();
            createJobCtrl.associatedRecruiterOptions = recruiterOptions;
            createJobCtrl.accountManagerRecruiterOptions = recruiterOptions;

            createJobCtrl.step = '1';
            createJobCtrl.previousSteps = {};
            createJobCtrl.jobCreated = false;
            createJobCtrl.summernoteOptions = {
                defaultFontName: 'Arial',
                toolbar: [
                    ['style', ['bold', 'italic', 'underline']],
                    ['alignment', ['ul']],
                    ['insert', ['ltr', 'rtl']],
                ],
                callbacks: {
                    onInit(summernote) {
                        summernote.toolbar.hide();
                        const $win = $(window); // or $box parent container
                        const $noteEditor = $('.note-editor');
                        $win.on('click.Bst', (event) => {
                            if ($noteEditor.has(event.target).length == 0 && !$noteEditor.is(event.target)) {
                                // click outside of summernote
                                summernote.toolbar.hide();
                            }
                        });
                        summernote.editable.focus(() => {
                            summernote.toolbar.show();
                        });
                    },
                },
            };
            createJobCtrl.positionId = $stateParams.positionId;
            createJobCtrl.criteriaFields = RouteService.getSystemPreference('searchCriteriaFields');
            createJobCtrl.JobTitleValuesCount = RouteService.getSystemPreference('filteredValuesCount');
            createJobCtrl.JobTitleValuesDynamicDelay = RouteService.getSystemPreference('filteredValuesDynamicDelay');
            createJobCtrl.editPosition = false;
            if ($stateParams.positionId) {
                createJobCtrl.editPosition = true;
                PositionService.getPosition($stateParams.positionId)
                    .then((response) => {
                        createJobCtrl.newPosition = response.result;
                        if (!createJobCtrl.newPosition.tipsForRecruiters
                            || createJobCtrl.newPosition.tipsForRecruiters.length === 0) {
                            createJobCtrl.newPosition.tipsForRecruiters = RouteService.getSystemPreference('tipsForTalentExpert');
                        }
                        if (createJobCtrl.newPosition.isPublic === undefined) {
                            createJobCtrl.newPosition.isPublic = false;
                        }
                        for (let i = 0; i < createJobCtrl.criteriaFields.length; i++) {
                            if (createJobCtrl.criteriaFields[i].type === 'minMaxStatic') {
                                const minIndex = _.findIndex(createJobCtrl.newPosition.desiredCandidateProfile.selected, {
                                    field: createJobCtrl.criteriaFields[i].minField,
                                });
                                const maxIndex = _.findIndex(createJobCtrl.newPosition.desiredCandidateProfile.selected, {
                                    field: createJobCtrl.criteriaFields[i].maxField,
                                });
                                if (minIndex >= 0 || maxIndex >= 0) {
                                    createJobCtrl.criteriaFields[i].check = true;
                                    if (minIndex >= 0) {
                                        createJobCtrl.criteriaFields[i].minSelected = createJobCtrl.newPosition.desiredCandidateProfile.selected[minIndex].items;
                                    }
                                    if (maxIndex >= 0) {
                                        createJobCtrl.criteriaFields[i].maxSelected = createJobCtrl.newPosition.desiredCandidateProfile.selected[maxIndex].items;
                                    }
                                } else {
                                    createJobCtrl.criteriaFields[i].check = false;
                                }
                            } else {
                                const index = _.findIndex(createJobCtrl.newPosition.desiredCandidateProfile.selected, {
                                    field: createJobCtrl.criteriaFields[i].field,
                                });
                                if (index >= 0) {
                                    createJobCtrl.criteriaFields[i].check = true;
                                    createJobCtrl.criteriaFields[i].selected = createJobCtrl.newPosition.desiredCandidateProfile.selected[index].items;
                                } else {
                                    createJobCtrl.criteriaFields[i].check = false;
                                }
                            }
                        }
                        createJobCtrl.newPosition.desiredCandidateProfile.selected = [];
                    })
                    .catch((err) => logger.error(err))
                    .finally(() => {
                        $scope.$apply();
                    });
            } else {
                const feedbackRecipients = [userData?.email].filter(Boolean);
                createJobCtrl.newPosition = {
                    employerId: createJobCtrl.employerCtrl.employerData._id,
                    employerRepId,
                    recruiterId,
                    maxNumOfRecruiters: RouteService.getSystemDefaults('maxTalentExpertsPerPosition') || 1,
                    salary: {},
                    functionalRole: '',
                    contact: {},
                    isPublic: false,
                    employerContactCandidates: true,
                    placementFee: {
                        unit: 'USD',
                        sum: 0,
                    },
                    numOfPositions: 1,
                    desiredCandidateProfile: {
                        searchCountries: [
                            {
                                code: '1234',
                            },
                            {
                                code: '9876',
                            },
                            {
                                code: '5555',
                            },
                        ],
                        searchLanguages: [
                            {
                                code: '1234',
                            },
                        ],
                        maxItems: 100,
                        selected: [],
                    },
                    resumeReceivingMethod: {
                        systemType: 'Talenya TFT',
                    },
                    tipsForRecruiters: RouteService.getSystemPreference('tipsForTalentExpert'),
                    feedbackRecipients,
                    locations: [],
                };
            }

            createJobCtrl.initStaticData = function () {
                staticDataService.getStaticData('applyType', (data) => {
                    const applyTypes = data.map(({ text }) => ({
                        label: text,
                        value: text,
                    }));
                    const firstItem = applyTypes.length > 0 && applyTypes[0];
                    const isNotDefinedSystemType = !_.get(createJobCtrl, 'newPosition.resumeReceivingMethod.systemType');

                    if (firstItem && isNotDefinedSystemType) {
                        createJobCtrl.newPosition.resumeReceivingMethod = createJobCtrl.newPosition.resumeReceivingMethod || {};
                        createJobCtrl.newPosition.resumeReceivingMethod.systemType = firstItem.value;
                    }

                    createJobCtrl.applyTypes = applyTypes;
                });

                staticDataService.getStaticData('functionalRole', (data) => {
                    createJobCtrl.functionalRoles = data;
                    createJobCtrl.filteredFunctionalRoles = data;
                    if (!createJobCtrl.editPosition) {
                        createJobCtrl.newPosition.functionalRole = '';
                    }
                });

                staticDataService.getStaticData('employmentType', (data) => {
                    createJobCtrl.employmentTypes = data;
                    if (createJobCtrl.employmentTypes.length > 0 && createJobCtrl.employmentTypes[0]) {
                        createJobCtrl.newPosition.employmentType = createJobCtrl.employmentTypes[0].text;
                    }
                });

                createJobCtrl.publishWebsiteOptions = [{
                    label: 'YES',
                    value: true,
                }, {
                    label: 'NO',
                    value: false,
                }];

                createJobCtrl.sourceOptions = [{
                    label: 'WEB_SITE',
                    value: 'self_service',
                }, {
                    label: 'TFT',
                    value: 'tft',
                }];
            };

            createJobCtrl.validtor = {
                1: validateFirstStep,
                2: validateSecondStep,
                2.5: validateSecondHalfStep,
                3: validateThirdStep,
                4: validateFourthStep,
            };
        };

        createJobCtrl.initPlacementFeeUnit = function () {
            staticDataService.getStaticData('currencies', (placementFreeUnit) => {
                $timeout(() => {
                    createJobCtrl.placementFreeUnit = angular.copy(placementFreeUnit);
                    createJobCtrl.placementFreeUnitOptions = (placementFreeUnit || [])
                        .map(({ code, name, symbol }) => ({
                            label: `${code} ${name}`,
                            value: code,
                            symbol,
                        }));

                    const defaultCode = _.get(createJobCtrl, 'newPosition.placementFee.unit', 'USD');
                    const selectedUnit = (placementFreeUnit || []).find(({ code }) => code === defaultCode);

                    if (selectedUnit) {
                        createJobCtrl.selectedPlacementFeeSymbol = selectedUnit.symbol || selectedUnit.code;
                    }
                });
            });
        };

        createJobCtrl.initAddress = function () {
            if (!createJobCtrl.newPosition.locations) {
                if (createJobCtrl.employerData.locations.length > 0) {
                    createJobCtrl.newPosition.locations = createJobCtrl.employerData.locations;
                }
            }
        };

        createJobCtrl.initContactNumber = function () {
            if (!createJobCtrl.editPosition) {
                if (createJobCtrl.employerData.contact.phone.length > 0) {
                    createJobCtrl.newPosition.contact.phone = [createJobCtrl.employerData.contact.phone[0]];
                }
            }
        };

        createJobCtrl.initEmailAddress = function () {
            if (!createJobCtrl.editPosition) {
                if (createJobCtrl.employerData.contact.email.length > 0) {
                    createJobCtrl.newPosition.contact.email = [createJobCtrl.employerData.contact.email[0]];
                }
            }
        };

        createJobCtrl.triggerFormSubmit = function (formName) {
            $rootScope.$broadcast('makeSubmit', { formName });
        };

        let validateFirstStep = function (form) {
            form.$setSubmitted(true);
            createJobCtrl.continueJob = false;
            if (createJobCtrl.saveAsDraft && createJobCtrl.newPosition.jobTitle) {
                return createJobCtrl.saveJob(form, createJobCtrl.saveAsDraft);
            }
            createJobCtrl.saveAsDraft = false;
            if (form.$invalid) {
                return false;
            }
            if (createJobCtrl.newPosition.salary && createJobCtrl.newPosition.salary.from > createJobCtrl.newPosition.salary.to) {
                return false;
            }

            const numOfPositions = new Number(createJobCtrl.newPosition.numOfPositions);
            const isInvalidNumberOfPositions = numOfPositions.valueOf() <= 0 || Number.isNaN(numOfPositions);
            if (isInvalidNumberOfPositions) {
                form.howManyPositionsAreOpen.$invalid = true;
                return false;
            }

            createJobCtrl.continueJob = true;
            createJobCtrl.autoSave();
            return true;
        };

        let validateSecondStep = function (form) {
            form.$setSubmitted(true);
            let count = 0;
            if (createJobCtrl.saveAsDraft == true) {
                createJobCtrl.newPosition.desiredCandidateProfile.selected = [];
            }
            for (let i = 0; i < createJobCtrl.criteriaFields.length; i++) {
                const criteria = createJobCtrl.criteriaFields[i];
                if (criteria.check == true) {
                    count++;

                    if (createJobCtrl.saveAsDraft) {
                        if (criteria.selected) {
                            createJobCtrl.newPosition.desiredCandidateProfile.selected.push({
                                field: criteria.field,
                                items: criteria.selected,
                            });
                        } else if (criteria.minSelected || criteria.maxSelected) {
                            createJobCtrl.newPosition.desiredCandidateProfile.selected.push({
                                field: criteria.minField,
                                items: criteria.minSelected,
                            });
                            createJobCtrl.newPosition.desiredCandidateProfile.selected.push({
                                field: criteria.maxField,
                                items: criteria.maxSelected,
                            });
                        }
                    }
                }
            }
            if (createJobCtrl.saveAsDraft == true) {
                createJobCtrl.saveJob(form, createJobCtrl.saveAsDraft);
            }
            createJobCtrl.parametersChosen = count;
            return (count >= 3);
        };

        let validateSecondHalfStep = function (form) {
            let validated = false;
            createJobCtrl.newPosition.desiredCandidateProfile.selected = [];
            for (let i = 0; i < createJobCtrl.criteriaFields.length; i++) {
                if (createJobCtrl.criteriaFields[i].check == true) {
                    if (createJobCtrl.criteriaFields[i].selected) {
                        const newSelected = {
                            field: createJobCtrl.criteriaFields[i].field,
                            items: createJobCtrl.criteriaFields[i].selected,
                        };
                        createJobCtrl.newPosition.desiredCandidateProfile.selected.push(newSelected);
                        if (createJobCtrl.criteriaFields[i].selected.length > 0) {
                            validated = true;
                        }
                    } else if (createJobCtrl.criteriaFields[i].minSelected || createJobCtrl.criteriaFields[i].maxSelected) {
                        createJobCtrl.newPosition.desiredCandidateProfile.selected.push({
                            field: createJobCtrl.criteriaFields[i].minField,
                            items: createJobCtrl.criteriaFields[i].minSelected,
                        });
                        createJobCtrl.newPosition.desiredCandidateProfile.selected.push({
                            field: createJobCtrl.criteriaFields[i].maxField,
                            items: createJobCtrl.criteriaFields[i].maxSelected,
                        });
                        if (createJobCtrl.criteriaFields[i].minSelected.length > 0 || createJobCtrl.criteriaFields[i].maxSelected.length > 0) {
                            validated = true;
                        }
                    }
                }
            }
            if (createJobCtrl.saveAsDraft == true) {
                return createJobCtrl.saveJob(form, createJobCtrl.saveAsDraft);
            }
            createJobCtrl.criteriaChosen = validated;
            return validated;
        };

        let validateThirdStep = function (form) {
            form.$setSubmitted(true);
            if (createJobCtrl.saveAsDraft == true) {
                return createJobCtrl.saveJob(form, createJobCtrl.saveAsDraft);
            }
            if (form.$invalid) {
                angular.forEach(form.$error, (field) => {
                    angular.forEach(field, (errorField) => {
                        errorField.$setTouched();
                    });
                });
                return;
            }
            createJobCtrl.saveJob(form);
            return true;
        };

        let validateFourthStep = function () {
            return true;
        };

        createJobCtrl.goToResumes = function () {
            createJobCtrl.step = '4';
        };

        createJobCtrl.continue = function (next, form) {
            $timeout(() => {
                if (createJobCtrl.validtor[createJobCtrl.step](form, next) == true) {
                    createJobCtrl.previousSteps[next] = createJobCtrl.step;
                    createJobCtrl.step = next;
                }
            });
        };

        createJobCtrl.back = function () {
            if (createJobCtrl.previousSteps[createJobCtrl.step]) {
                createJobCtrl.step = createJobCtrl.previousSteps[createJobCtrl.step];
            }
        };

        createJobCtrl.deleteJob = function () {
            PositionService.deletePosition(createJobCtrl.newPosition._id)
                .then(() => {
                    WebAppRouteService.goPositionsPage({
                        employerId: createJobCtrl.employerData._id,
                    });
                })
                .catch((err) => logger.error(err));
        };

        createJobCtrl.getTalents = function () {
            createJobCtrl.newPosition.desiredCandidateProfile.maxItems = 100;
            createJobCtrl.loadingCandidates = true;
            TalentScoreService.postTalentScore(createJobCtrl.newPosition.desiredCandidateProfile)
                .then((response) => {
                    if (response.errorCode == 'SUCCESS') {
                        if (response.result) {
                            createJobCtrl.candidates = response.result;
                            createJobCtrl.candidates.resultList = createJobCtrl.candidates.resultList.slice(0, 4);
                            const candidates = {
                                talentIDs: [],
                            };
                            for (let i = 0; i < createJobCtrl.candidates.resultList.length; i++) {
                                candidates.talentIDs.push(createJobCtrl.candidates.resultList[i].talentID);
                            }
                            if (candidates.talentIDs.length == 0) {
                                createJobCtrl.loadingCandidates = false;

                                return WebAppRouteService.goToViewJobPage($stateParams);
                            }
                            createJobCtrl.candidates.resultListLength = createJobCtrl.candidates.resultList.length;
                            TalentService.postTalents(candidates)
                                .then((response) => {
                                    if (response.errorCode == 'SUCCESS') {
                                        for (let i = 0; i < response.result.length; i++) {
                                            const candidate = _.find(createJobCtrl.candidates.resultList, {
                                                talentID: response.result[i].talentId,
                                            });
                                            if (candidate) {
                                                // candidate.check = false;
                                                candidate.candidateData = response.result[i];
                                                candidate.candidateData.matchScore = candidate.matchScore;
                                                candidate.currentJob = _.find(candidate.candidateData.employmentHistory, { isCurrent: true });
                                                candidate.previousJob = _.find(candidate.candidateData.employmentHistory, { isCurrent: false });
                                                candidate.skills = candidate.candidateData.skills.slice(0, 5);
                                                candidate.residency = '';
                                                if (candidate.candidateData.residency.city) {
                                                    candidate.residency = candidate.candidateData.residency.city;
                                                }
                                                if (candidate.candidateData.residency.region || candidate.candidateData.residency.state) {
                                                    if (candidate.residency) {
                                                        candidate.residency = `${candidate.residency}, `;
                                                    }
                                                    candidate.residency = `${candidate.residency + (candidate.candidateData.residency.region || '')} ${candidate.candidateData.residency.state || ''}`;
                                                }
                                                if (candidate.candidateData.residency.country) {
                                                    if (candidate.residency) {
                                                        candidate.residency = `${candidate.residency}, `;
                                                    }
                                                    candidate.residency += candidate.candidateData.residency.country;
                                                }
                                            }
                                        }
                                        createJobCtrl.candidateIndex = 0;
                                        createJobCtrl.loadingCandidates = false;
                                    }
                                })
                                .catch((err) => logger.error(err));
                        } else {
                            createJobCtrl.candidates = {
                                resultListLength: 0,
                            };
                            createJobCtrl.candidateIndex = 0;
                            createJobCtrl.loadingCandidates = false;

                            return WebAppRouteService.goToViewJobPage($stateParams);
                        }
                    } else {
                        createJobCtrl.candidates = {
                            resultListLength: 0,
                        };
                        createJobCtrl.candidateIndex = 0;
                        createJobCtrl.loadingCandidates = false;

                        return WebAppRouteService.goToViewJobPage($stateParams);
                    }
                })
                .catch((err) => logger.error(err));
        };

        createJobCtrl.createUpdatePosition = function (saveAsDraft) {
            const { newPosition } = createJobCtrl;

            delete newPosition.feedbackOnCandidates;

            PositionService.addPosition(newPosition, createJobCtrl.editPosition)
                .then(({ result }) => {
                    if (result && result._id) {
                        createJobCtrl.positionId = result._id;
                    }
                    if (saveAsDraft) {
                        createJobCtrl.goToPositionPage(createJobCtrl.employerData._id);
                        return;
                    } if (!createJobCtrl.newPosition.status || createJobCtrl.newPosition.status.current === 'Draft') {
                        PositionService.changePositionStatus(createJobCtrl.newPosition._id || result._id, { status: 'Ready' })
                            .catch((err) => logger.error(err));
                    }
                    $localStorage[createJobCtrl.positionId] = null;
                    if (createJobCtrl.isEmployer) {
                        createJobCtrl.goToPositionPage(createJobCtrl.employerData._id);
                    } else {
                        $state.go('recruiter.openPosition', { positionId: createJobCtrl.positionId }, { reload: true });
                    }
                    $('#job-flow-third')
                        .animate({ left: '-130%' }, function () {
                            $(this)
                                .hide();
                            $('#job-flow-fin')
                                .delay(300)
                                .fadeIn();
                        });
                })
                .catch((err) => logger.error(err));
        };

        createJobCtrl.goToPositionPage = (employerId) => {
            WebAppRouteService.goPositionsPage({
                employerId: employerId || createJobCtrl.employerData._id,
            });
        };

        createJobCtrl.saveJob = function (form, saveAsDraft, next) {
            createJobCtrl.createUpdatePosition(saveAsDraft, next);
        };

        createJobCtrl.functionalRoleChanged = function () {
            if (createJobCtrl.newPosition.functionalRole == '') {
                createJobCtrl.functionalRoleFocusedOn = 0;
                createJobCtrl.filteredFunctionalRoles = createJobCtrl.functionalRoles;
                return;
            }
            const ans = [];
            for (let i = 0; i < createJobCtrl.functionalRoles.length; i++) {
                if (createJobCtrl.newPosition.functionalRole && createJobCtrl.functionalRoles[i].text.toLowerCase()
                    .indexOf(createJobCtrl.newPosition.functionalRole.toLowerCase()) >= 0) {
                    ans.push(createJobCtrl.functionalRoles[i]);
                }
            }
            createJobCtrl.functionalRoleFocusedOn = 0;
            createJobCtrl.functionalRoleDropDownShowen = true;
            createJobCtrl.filteredFunctionalRoles = ans;
        };

        createJobCtrl.jobTitleChanged = function () {
            if (createJobCtrl.JobTitleGetDataDelay) {
                $timeout.cancel(createJobCtrl.JobTitleGetDataDelay);
                createJobCtrl.jobTitleShowDropDown = false;
            }
            if (createJobCtrl.newPosition.jobTitle && createJobCtrl.newPosition.jobTitle.length > 1) {
                createJobCtrl.JobTitleGetDataDelay = $timeout(() => {
                    const requestBody = {
                        currentField: {
                            field: 'jobTitles',
                            type: 'Text',
                            value: createJobCtrl.newPosition.jobTitle,
                            matchType: 'contains',
                        },
                        searchCountries: [
                            {
                                code: 'US',
                            },
                        ],
                        maxItems: createJobCtrl.JobTitleValuesCount,
                        searchLanguages: [
                            {
                                code: 'en-US',
                            },
                        ],
                        selected: [],
                    };
                    dynamicDataService.getFilteredValues(requestBody)
                        .then((response) => {
                            createJobCtrl.jobTitlefocusedOn = 0;
                            createJobCtrl.jobTitleFilteredData = response.result;
                            createJobCtrl.jobTitleShowDropDown = true;
                        })
                        .catch((err) => logger.error(err));
                }, createJobCtrl.JobTitleValuesDynamicDelay, false);
            }
        };

        createJobCtrl.jobTitleCheckIfEnterKeyWasPressed = function (event) {
            const keyCode = event.which || event.keyCode;
            if (keyCode === 13) {
                if (createJobCtrl.JobTitleGetDataDelay) {
                    $timeout.cancel(createJobCtrl.JobTitleGetDataDelay);
                }
                createJobCtrl.jobTitleShowDropDown = false;
                event.preventDefault();
            }
        };

        createJobCtrl.finish = function () {
            if (createJobCtrl.isEmployer) {
                return WebAppRouteService.goToViewJobPage($stateParams);
            }
            $state.go('recruiter.openPosition', { positionId: createJobCtrl.positionId });
        };

        createJobCtrl.rateCandidate = function (type, rateNumber) {
            createJobCtrl.candidates.resultList[createJobCtrl.candidateIndex][type] = rateNumber;
        };

        createJobCtrl.getNumberOfStars = function (size) {
            return new Array(size);
        };

        createJobCtrl.insertPhone = function (form) {
            if (form.$invalid) {
                return;
            }
            const tempEmployer = angular.copy(createJobCtrl.employerData);
            tempEmployer.contact.phone.push({
                value: createJobCtrl.phone.value,
                type: createJobCtrl.phone.type,
            });
            EmployerService.putEmployer(tempEmployer._id, tempEmployer)
                .then(() => {
                    createJobCtrl.employerData.contact.phone.push({
                        value: createJobCtrl.phone.value,
                        type: createJobCtrl.phone.type,
                    });
                    createJobCtrl.newPosition.contact.phone = [{
                        value: createJobCtrl.phone.value,
                        type: createJobCtrl.phone.type,
                    }];
                    createJobCtrl.phone.value = '';
                    createJobCtrl.phone.type = '';
                    createJobCtrl.showAddPhoneModal = false;
                    $('#modal-add-phone')
                        .modal('hide');
                })
                .catch((err) => logger.error(err));
        };

        createJobCtrl.insertEmail = function (form) {
            if (form.$invalid) {
                return;
            }
            const tempEmployer = angular.copy(createJobCtrl.employerData);
            tempEmployer.contact.email.push({
                value: createJobCtrl.email.value,
                type: createJobCtrl.email.type,
            });
            EmployerService.putEmployer(tempEmployer._id, tempEmployer)
                .then(() => {
                    createJobCtrl.employerData.contact.email.push({
                        value: createJobCtrl.email.value,
                        type: createJobCtrl.email.type,
                    });
                    createJobCtrl.newPosition.contact.email = [{
                        value: createJobCtrl.email.value,
                        type: createJobCtrl.email.type,
                    }];
                    createJobCtrl.email.value = '';
                    createJobCtrl.email.type = '';
                    createJobCtrl.showAddEmailModal = false;
                    $('#modal-add-email')
                        .modal('hide');
                })
                .catch((err) => logger.error(err));
        };

        createJobCtrl.getLocationLangLat = function (location) {
            const deferred = $q.defer();
            LocationService.getLognitudeLatitude(location.country, location.city, location.streetAddress)
                .then((response) => {
                    if (response.data && response.data.results && response.data.results.length > 0) {
                        location.latitude = response.data.results[0].geometry.location.lat;
                        location.longitude = response.data.results[0].geometry.location.lng;
                        return deferred.resolve(location);
                    }
                    if (response.data.status == 'ZERO_RESULTS') {
                        return LocationService.getLognitudeLatitude(location.country, location.city, '')
                            .then((response) => {
                                if (response.data && response.data.results && response.data.results.length > 0) {
                                    location.latitude = response.data.results[0].geometry.location.lat;
                                    location.longitude = response.data.results[0].geometry.location.lng;
                                    return deferred.resolve(location);
                                }
                                deferred.resolve(null);
                            })
                            .catch((err) => logger.error(err));
                    }
                    deferred.resolve(null);
                })
                .catch((err) => logger.error(err));
            return deferred.promise;
        };

        createJobCtrl.insertAddress = function (form) {
            if (form.$invalid) {
                return;
            }
            const tempEmployer = angular.copy(createJobCtrl.employerData);
            const promise = createJobCtrl.getLocationLangLat(createJobCtrl.location);
            promise.then(() => {
                tempEmployer.locations.push({
                    locationName: createJobCtrl.location.locationName,
                    country: createJobCtrl.location.country,
                    state: createJobCtrl.location.state,
                    city: createJobCtrl.location.city,
                    streetAddress: createJobCtrl.location.streetAddress,
                    zipCode: createJobCtrl.location.zipCode,
                    longitude: createJobCtrl.location.longitude,
                    latitude: createJobCtrl.location.latitude,
                });
                EmployerService.putEmployer(tempEmployer._id, tempEmployer)
                    .then(() => {
                        createJobCtrl.employerData.locations.push({
                            locationName: createJobCtrl.location.locationName,
                            country: createJobCtrl.location.country,
                            state: createJobCtrl.location.state,
                            city: createJobCtrl.location.city,
                            streetAddress: createJobCtrl.location.streetAddress,
                            zipCode: createJobCtrl.location.zipCode,
                            longitude: createJobCtrl.location.longitude,
                            latitude: createJobCtrl.location.latitude,
                        });
                        createJobCtrl.newPosition.locations.push({
                            locationName: tempEmployer.locations[tempEmployer.locations.length - 1].locationName,
                            country: tempEmployer.locations[tempEmployer.locations.length - 1].country,
                            state: tempEmployer.locations[tempEmployer.locations.length - 1].state,
                            city: tempEmployer.locations[tempEmployer.locations.length - 1].city,
                            streetAddress: tempEmployer.locations[tempEmployer.locations.length - 1].streetAddress,
                            zipCode: tempEmployer.locations[tempEmployer.locations.length - 1].zipCode,
                            longitude: tempEmployer.locations[tempEmployer.locations.length - 1].longitude,
                            latitude: tempEmployer.locations[tempEmployer.locations.length - 1].latitude,
                        });
                        createJobCtrl.showAddAddressModal = false;
                        $('#modal-add-address')
                            .modal('hide');
                        createJobCtrl.location.locationName = '';
                        createJobCtrl.location.country = '';
                        createJobCtrl.location.state = '';
                        createJobCtrl.location.city = '';
                        createJobCtrl.location.streetAddress = '';
                        createJobCtrl.location.zipCode = '';
                        createJobCtrl.location.longitude = '';
                        createJobCtrl.location.latitude = '';
                    })
                    .catch((err) => logger.error(err));
            }).catch((err) => logger.error(err));
        };

        createJobCtrl.cityChanged = function (location, index) {
            createJobCtrl.currentCityIndex = index;
            if (location.city == '') {
                createJobCtrl.cityFocusedOn = 0;
                createJobCtrl.filteredCity = location.countries[location.countryId].states[location.state];
                return;
            }
            const ans = [];
            for (let i = 0; i < location.countries[location.countryId].states[location.state].length; i++) {
                if (location.countries[location.countryId].states[location.state][i].toLowerCase()
                    .indexOf(location.city.toLowerCase()) >= 0) {
                    ans.push(location.countries[location.countryId].states[location.state][i]);
                }
            }
            createJobCtrl.cityFocusedOn = 0;
            location.showDropDownCity = true;
            createJobCtrl.filteredCity = ans;
        };

        createJobCtrl.autoSave = function () {
            if (!createJobCtrl.newPosition) {
                return;
            }
            createJobCtrl.newPositionAuto = angular.copy(createJobCtrl.newPosition);

            // to save the selected parameters
            createJobCtrl.newPositionAuto.desiredCandidateProfile.selected = [];

            for (let i = 0; i < createJobCtrl.criteriaFields.length; i++) {
                const criteria = createJobCtrl.criteriaFields[i];
                if (criteria.check === true) {
                    if (criteria.field === 'locations') {
                        createJobCtrl.newPositionAuto.locations = createJobCtrl.getLocationCollectionFromLocationCriteria({
                            locationCriteria: criteria,
                            staticData: createJobCtrl.lookupCountries,
                        });
                    }

                    if (createJobCtrl.criteriaFields[i].selected) {
                        const newSelected = {
                            field: createJobCtrl.criteriaFields[i].field,
                            items: createJobCtrl.criteriaFields[i].selected,
                        };
                        createJobCtrl.newPositionAuto.desiredCandidateProfile.selected.push(newSelected);
                    } else if (createJobCtrl.criteriaFields[i].minSelected || createJobCtrl.criteriaFields[i].maxSelected) {
                        createJobCtrl.newPositionAuto.desiredCandidateProfile.selected.push({
                            field: createJobCtrl.criteriaFields[i].minField,
                            items: createJobCtrl.criteriaFields[i].minSelected,
                        });
                        createJobCtrl.newPositionAuto.desiredCandidateProfile.selected.push({
                            field: createJobCtrl.criteriaFields[i].maxField,
                            items: createJobCtrl.criteriaFields[i].maxSelected,
                        });
                    }
                }
            }

            createJobCtrl.newPosition = createJobCtrl.newPositionAuto;

            PositionService.addPosition(createJobCtrl.newPositionAuto, createJobCtrl.editPosition)
                .then((response) => {
                    const savedPosition = _.get(response, 'result');
                    if (savedPosition && !createJobCtrl.newPosition._id) {
                        createJobCtrl.newPosition._id = savedPosition._id;
                        createJobCtrl.newPosition.status = savedPosition.status;
                        createJobCtrl.newPosition.associatedRecruiter = savedPosition.associatedRecruiter;
                        createJobCtrl.newPosition.accountManagerRecruiter = savedPosition.accountManagerRecruiter;
                        $state.transitionTo('employer.createJob', {
                            employerId: $stateParams.employerId,
                            positionId: createJobCtrl.newPosition._id,
                        }, {
                            notify: false,
                        });
                    }
                    createJobCtrl.editPosition = true;
                })
                .catch((err) => logger.error(err));
        };

        $scope.$watch('createJobCtrl.criteriaFields', () => {
            if (createJobCtrl.step != '1') {
                createJobCtrl.autoSave();
            }
        }, true);
        // createJobCtrl.init();

        createJobCtrl.onApplyType = ({ value }) => {
            createJobCtrl.newPosition.resumeReceivingMethod.systemType = value;
            createJobCtrl.autoSave();
        };

        createJobCtrl.onPublishWebsiteOptionSelect = ({ value }) => {
            createJobCtrl.newPosition.isPublic = value;
            createJobCtrl.autoSave();
        };

        createJobCtrl.onCriteriaFieldCheck = (value, field) => {
            field.check = value;
        };

        createJobCtrl.onSourceOptionSelect = ({ value }) => {
            createJobCtrl.newPosition.source = value;
        };

        createJobCtrl.onAccountManagerRecruiterChange = ({ value }) => {
            createJobCtrl.newPosition.accountManagerRecruiter = value;
        };

        createJobCtrl.onAssociatedRecruiterChange = ({ value }) => {
            createJobCtrl.newPosition.associatedRecruiter = value;
        };

        createJobCtrl.onPlacementFeeUnitOptionClick = ({ value, symbol }) => {
            createJobCtrl.newPosition.placementFee.unit = value;
            createJobCtrl.selectedPlacementFeeSymbol = symbol || value;
            createJobCtrl.autoSave();
        };

        createJobCtrl.getFormattedLocationTitle = (location) => [
                location?.streetAddress,
                location?.city,
                location?.country,
        ].filter(Boolean).join(', ');

        createJobCtrl.getLocationCollectionFromLocationCriteria = ({ locationCriteria, staticData } = {}) => {
            const locations = _.get(locationCriteria, 'selected', [{ text: '' }]);

            return locations.map((location) => {
                const locationValue = _.get(location, 'value', '');

                const isNationWideLocation = !_.isString(locationValue);

                const [
                    latitude = '',
                    longitude = '',
                ] = isNationWideLocation ? [] : locationValue.split(',');

                const countriesNameList = _.chain(staticData)
                    .map('Name')
                    .value();

                const locationTextArr = _.get(location, 'text', '')
                    .split(',')
                    .map((item) => item.trim());

                let { city = '', state = '', country = '' } = {};
                if (locationTextArr && locationTextArr.length === 3) {
                    [city, state, country] = locationTextArr;
                } else if (locationTextArr && locationTextArr.length === 2) {
                    if (countriesNameList
                        && countriesNameList.includes(locationTextArr[1])) {
                        [city, country] = locationTextArr;
                    } else {
                        [city, state] = locationTextArr;
                    }
                } else if (locationTextArr && locationTextArr.length === 1) {
                    if (countriesNameList
                        && countriesNameList.includes(locationTextArr[0])) {
                        [country] = locationTextArr;
                    } else {
                        [city] = locationTextArr;
                    }
                }

                return {
                    locationName: location.text,
                    city,
                    state,
                    country,
                    latitude,
                    longitude,
                };
            });
        };
    }
}

export const CreateJobComponentConfiguration = {
    template,
    require: {
        employerCtrl: '?^employerComponent',
        recruiterCtrl: '?^recruiterComponent',
    },
    controller: CreateJobComponent,
    controllerAs: 'createJobCtrl',
};

angular
    .module('TALENYA-FE')
    .component('createJobComponent', CreateJobComponentConfiguration);
